import React from "react";
import styles from "./TemplateFooter.module.css";
import logo from "../../contexts/logo.png";

const TemplateFooter = () => {
  return (
    <footer className={styles.siteFooter} aria-label="Site footer">
      <div className={styles.footerInner}>
        {/* CTA Banner */}
        <section className={styles.ctaBanner} aria-labelledby="cta-heading">
          <div className={styles.ctaContent}>
            <h2 id="cta-heading" className={styles.ctaTitle}>
              Build Smarter Software with Us.
            </h2>
            <ul className={styles.ctaBenefits} aria-label="Key benefits">
              <li>
                <CheckIcon aria-hidden="true" />
                <span>Full-stack solutions (MERN, Kotlin, Python)</span>
              </li>
              <li>
                <CheckIcon aria-hidden="true" />
                <span>AI-powered scalability and automation</span>
              </li>
              <li>
                <CheckIcon aria-hidden="true" />
                <span>From concept to deployment in weeks</span>
              </li>
            </ul>
          </div>

          <div
            className={styles.ctaActions}
            role="group"
            aria-label="Primary actions"
          >
            <a
              href="https://calendly.com/evolvebay/30min"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.btn} ${styles["btn--primary"]}`}
              aria-label="Book an appointment"
            >
              <span>Get Started</span>
              <ArrowRight aria-hidden="true" />
            </a>
            <a
              href="/#contact"
              className={`${styles.btn} ${styles["btn--outline"]}`}
              aria-label="Talk to our team"
            >
              <span>Contact Us</span>
              <ArrowRight aria-hidden="true" />
            </a>
          </div>
        </section>

        {/* Main grid */}
        <div className={styles["footer-grid"]}>
          <div className={styles.brand}>
            <img src={logo} alt="EvolveBay" width={50} height={50} />
            <span className={styles.brandName}>EvolveBay</span>
          </div>

          <nav className={styles.linkGroup} aria-label="Explore">
            <h3 className={styles.groupTitle}>Explore</h3>
            <ul>
              <li>
                <a href="/#services">Services</a>
              </li>
              <li>
                <a href="/#our-work-flow">Our Work Flow</a>
              </li>
              <li>
                <a href="/#testimonials">Testimonials</a>
              </li>
              <li>
                <a href="/#contact">Contact</a>
              </li>
            </ul>
          </nav>

          <nav className={styles.linkGroup} aria-label="Connect">
            <h3 className={styles.groupTitle}>Connect</h3>
            <ul>
              <li>
                <a
                  href="https://pk.linkedin.com/company/evolvebay"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </nav>
        </div>

        {/* Bottom bar */}
        <div
          className={styles["footer-bottom"]}
          role="contentinfo"
          aria-label="Footer meta"
        >
          <div className={styles.legal}>
            <span>©{new Date().getFullYear()} EvolveBay</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default TemplateFooter;

function CheckIcon(props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M4 10l4 4 8-8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowRight(props) {
  return (
    <svg
      className={styles["icon-arrow"]}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M5 12h14M13 5l7 7-7 7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
